import { parse } from 'qs';
import { ROUTE_CHANGE, SET_LAYOUT, EVT_REF } from 'actionTypes';
import detectLayout from './detectLayout';

export default history => dispatch => {
  const onRouteChange = (location, action) => {
    const { pathname, search, hash, state, key } = location;
    const query = parse(search.slice(1));
    const { evt_ref } = query;
    const set_profiles_back = query.set_profiles_back || '';

    dispatch({
      type: ROUTE_CHANGE,
      payload: { pathname, search, query, method: action, hash, state, key },
    });

    dispatch({ type: SET_LAYOUT, payload: detectLayout(pathname, search) });

    dispatch({ type: EVT_REF, payload: { evt_ref, set_profiles_back } });
  };
  history.listen(onRouteChange);
  onRouteChange(history.location, 'push');
};
